import Plugin from '@jbrowse/core/Plugin';
// locals
import GCContentAdapterF from './GCContentAdapter';
import GCContentTrackF from './GCContentTrack';
import LinearGCContentDisplayF from './LinearGCContentDisplay';
export default class GCContentPlugin extends Plugin {
    constructor() {
        super(...arguments);
        this.name = 'GCContentPlugin';
    }
    install(pluginManager) {
        GCContentAdapterF(pluginManager);
        GCContentTrackF(pluginManager);
        LinearGCContentDisplayF(pluginManager);
    }
}
